(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orelis-product-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeReviewCarousel = (section) => {
      if (section.dataset.orReviewsInitialized === 'true') return;

      const track = section.querySelector('[data-or-review-track]');
      if (!track) return;

      section.dataset.orReviewsInitialized = 'true';
      section.querySelectorAll('[data-or-review-direction]').forEach((button) => {
        button.addEventListener('click', () => {
          const firstCard = track.querySelector('.or-review-card');
          const styles = window.getComputedStyle(track);
          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
          const distance = firstCard ? firstCard.getBoundingClientRect().width + gap : track.clientWidth * 0.88;
          const direction = Number(button.dataset.orReviewDirection);
          track.scrollLeft = track.scrollLeft + direction * distance;
        });
      });
    };

    const initializeAllReviewCarousels = (scope = document) => {
      scope.querySelectorAll('[data-or-reviews]').forEach(initializeReviewCarousel);
    };

    initializeAllReviewCarousels();
    document.addEventListener('shopify:section:load', (event) => initializeAllReviewCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orelis-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeStickyBar = (sticky) => {
      if (sticky.dataset.orStickyInitialized === 'true') return;

      const stickyButton = sticky.querySelector('[data-or-sticky-button]');
      const optionText = sticky.querySelector('[data-or-sticky-option]');
      const getProductInfo = () => document.querySelector('[id^="ProductInfo-"]');
      const getMainButton = () => {
        const productInfo = getProductInfo();
        return productInfo && productInfo.querySelector('[id^="ProductSubmitButton-"]');
      };
      const productInfo = getProductInfo();
      const mainButton = getMainButton();
      if (!productInfo || !mainButton || !stickyButton) return;

      sticky.dataset.orStickyInitialized = 'true';

      const syncState = () => {
        const productInfo = getProductInfo();
        const currentMainButton = getMainButton();
        if (!productInfo || !currentMainButton) return;
        const checkedOption = productInfo.querySelector('variant-selects input[type="radio"]:checked, variant-radios input[type="radio"]:checked');
        if (checkedOption && optionText) optionText.textContent = checkedOption.value;
        stickyButton.disabled = currentMainButton.disabled;
        const mainLabel = currentMainButton.querySelector('span');
        if (mainLabel && mainLabel.textContent.trim()) stickyButton.textContent = mainLabel.textContent.trim();
      };

      stickyButton.addEventListener('click', () => {
        const currentMainButton = getMainButton();
        if (currentMainButton && !currentMainButton.disabled) currentMainButton.click();
      });

      document.addEventListener('change', (event) => {
        if (event.target.matches('variant-selects input[type="radio"], variant-radios input[type="radio"]')) {
          requestAnimationFrame(syncState);
        }
      });
      new MutationObserver(syncState).observe(mainButton, { attributes: true, childList: true, subtree: true });

      const updateVisibility = () => {
        const currentMainButton = getMainButton();
        sticky.classList.toggle('is-visible', Boolean(currentMainButton && currentMainButton.getBoundingClientRect().bottom < 0));
      };

      document.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
      updateVisibility();
      syncState();
    };

    const initializeAllStickyBars = (scope = document) => {
      scope.querySelectorAll('[data-or-sticky-atc]').forEach(initializeStickyBar);
    };

    initializeAllStickyBars();
    document.addEventListener('shopify:section:load', (event) => initializeAllStickyBars(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
